function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/utils/structure
 */
import TableWalker from '../tablewalker';
import { createEmptyTableCell, updateNumericAttribute } from './common';
/**
 * Returns a cropped table according to given dimensions.

 * To return a cropped table that starts at first row and first column and end in third row and column:
 *
 *		const croppedTable = cropTableToDimensions( table, {
 *			startRow: 1,
 *			endRow: 3,
 *			startColumn: 1,
 *			endColumn: 3
 *		}, writer );
 *
 * Calling the code above for the table below:
 *
 *		      0   1   2   3   4                      0   1   2
 *		    ┌───┬───┬───┬───┬───┐
 *		 0  │ a │ b │ c │ d │ e │
 *		    ├───┴───┤   ├───┴───┤                  ┌───┬───┬───┐
 *		 1  │ f     │   │ g     │                  │   │   │ g │  0
 *		    ├───┬───┴───┼───┬───┤   will return:   ├───┴───┼───┤
 *		 2  │ h │ i     │ j │ k │                  │ i     │ j │  1
 *		    ├───┤       ├───┤   │                  │       ├───┤
 *		 3  │ l │       │ m │   │                  │       │ m │  2
 *		    ├───┼───┬───┤   ├───┤                  └───────┴───┘
 *		 4  │ n │ o │ p │   │ q │
 *		    └───┴───┴───┴───┴───┘
 *
 * @param {module:engine/model/element~Element} sourceTable
 * @param {Object} cropDimensions
 * @param {Number} cropDimensions.startRow
 * @param {Number} cropDimensions.startColumn
 * @param {Number} cropDimensions.endRow
 * @param {Number} cropDimensions.endColumn
 * @param {module:engine/model/writer~Writer} writer
 * @returns {module:engine/model/element~Element}
 */

export function cropTableToDimensions(sourceTable, cropDimensions, writer) {
  var startRow = cropDimensions.startRow,
      startColumn = cropDimensions.startColumn,
      endRow = cropDimensions.endRow,
      endColumn = cropDimensions.endColumn; // Create empty table with empty rows equal to crop height.

  var croppedTable = writer.createElement('table');
  var cropHeight = endRow - startRow + 1;

  for (var i = 0; i < cropHeight; i++) {
    writer.insertElement('tableRow', croppedTable, 'end');
  }

  var tableMap = _toConsumableArray(new TableWalker(sourceTable, {
    startRow: startRow,
    endRow: endRow,
    startColumn: startColumn,
    endColumn: endColumn,
    includeAllSlots: true
  })); // Iterate over source table slots (including empty - spanned - ones).


  var _iterator = _createForOfIteratorHelper(tableMap),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ref2 = _step.value;
      var sourceRow = _ref2.row;
      var sourceColumn = _ref2.column;
      var tableCell = _ref2.cell;
      var isAnchor = _ref2.isAnchor;
      var cellAnchorRow = _ref2.cellAnchorRow;
      var cellAnchorColumn = _ref2.cellAnchorColumn;
      // Row index in cropped table.
      var rowInCroppedTable = sourceRow - startRow;
      var row = croppedTable.getChild(rowInCroppedTable); // For empty slots: fill the gap with empty table cell.

      if (!isAnchor) {
        // But fill the gap only if the spanning cell is anchored outside cropped area.
        // In the table from method jsdoc those cells are: "c" & "f".
        if (cellAnchorRow < startRow || cellAnchorColumn < startColumn) {
          createEmptyTableCell(writer, writer.createPositionAt(row, 'end'));
        }
      } // Otherwise clone the cell with all children and trim if it exceeds cropped area.
      else {
          var tableCellCopy = writer.cloneElement(tableCell);
          writer.append(tableCellCopy, row); // Trim table if it exceeds cropped area.
          // In the table from method jsdoc those cells are: "g" & "m".

          trimTableCellIfNeeded(tableCellCopy, sourceRow, sourceColumn, endRow, endColumn, writer);
        }
    } // Adjust heading rows & columns in cropped table if crop selection includes headings parts.

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  addHeadingsToCroppedTable(croppedTable, sourceTable, startRow, startColumn, writer);
  return croppedTable;
}
/**
 * Returns slot info of cells that starts above and overlaps a given row.
 *
 * In a table below, passing `overlapRow = 3`
 *
 *		   ┌───┬───┬───┬───┬───┐
 *		0  │ a │ b │ c │ d │ e │
 *		   │   ├───┼───┼───┼───┤
 *		1  │   │ f │ g │ h │ i │
 *		   ├───┤   ├───┼───┤   │
 *		2  │ j │   │ k │ l │   │
 *		   │   │   │   ├───┼───┤
 *		3  │   │   │   │ m │ n │  <- overlap row to check
 *		   ├───┼───┤   │   ├───│
 *		4  │ o │ p │   │   │ q │
 *		   └───┴───┴───┴───┴───┘
 *
 * will return slot info for cells: "j", "f", "k".
 *
 * @param {module:engine/model/element~Element} table The table to check.
 * @param {Number} overlapRow The index of the row to check.
 * @param {Number} [startRow=0] A row to start analysis. Use it when it is known that the cells above that row will not overlap.
 * @returns {Array.<module:table/tablewalker~TableSlot>}
 */

export function getVerticallyOverlappingCells(table, overlapRow) {
  var startRow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var cells = [];
  var tableWalker = new TableWalker(table, {
    startRow: startRow,
    endRow: overlapRow - 1
  });

  var _iterator2 = _createForOfIteratorHelper(tableWalker),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var slotInfo = _step2.value;
      var row = slotInfo.row,
          cellHeight = slotInfo.cellHeight;
      var cellEndRow = row + cellHeight - 1;

      if (row < overlapRow && overlapRow <= cellEndRow) {
        cells.push(slotInfo);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return cells;
}
/**
 * Splits the table cell horizontally.
 *
 * @param {module:engine/model/element~Element} tableCell
 * @param {Number} splitRow
 * @param {module:engine/model/writer~Writer} writer
 * @returns {module:engine/model/element~Element} Created table cell.
 */

export function splitHorizontally(tableCell, splitRow, writer) {
  var tableRow = tableCell.parent;
  var table = tableRow.parent;
  var rowIndex = tableRow.index;
  var rowspan = parseInt(tableCell.getAttribute('rowspan'));
  var newRowspan = splitRow - rowIndex;
  var newCellAttributes = {};
  var newCellRowSpan = rowspan - newRowspan;

  if (newCellRowSpan > 1) {
    newCellAttributes.rowspan = newCellRowSpan;
  }

  var colspan = parseInt(tableCell.getAttribute('colspan') || 1);

  if (colspan > 1) {
    newCellAttributes.colspan = colspan;
  }

  var startRow = rowIndex;
  var endRow = startRow + newRowspan;

  var tableMap = _toConsumableArray(new TableWalker(table, {
    startRow: startRow,
    endRow: endRow,
    includeAllSlots: true
  }));

  var newCell = null;
  var columnIndex;

  var _iterator3 = _createForOfIteratorHelper(tableMap),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var tableSlot = _step3.value;
      var row = tableSlot.row,
          column = tableSlot.column,
          cell = tableSlot.cell;

      if (cell === tableCell && columnIndex === undefined) {
        columnIndex = column;
      }

      if (columnIndex !== undefined && columnIndex === column && row === endRow) {
        newCell = createEmptyTableCell(writer, tableSlot.getPositionBefore(), newCellAttributes);
      }
    } // Update the rowspan attribute after updating table.

  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  updateNumericAttribute('rowspan', newRowspan, tableCell, writer);
  return newCell;
}
/**
 * Returns slot info of cells that starts before and overlaps a given column.
 *
 * In a table below, passing `overlapColumn = 3`
 *
 *		  0   1   2   3   4
 *		┌───────┬───────┬───┐
 *		│ a     │ b     │ c │
 *		│───┬───┴───────┼───┤
 *		│ d │ e         │ f │
 *		├───┼───┬───────┴───┤
 *		│ g │ h │ i         │
 *		├───┼───┼───┬───────┤
 *		│ j │ k │ l │ m     │
 *		├───┼───┴───┼───┬───┤
 *		│ n │ o     │ p │ q │
 *		└───┴───────┴───┴───┘
 *		              ^
 *		              Overlap column to check
 *
 * will return slot info for cells: "b", "e", "i".
 *
 * @param {module:engine/model/element~Element} table The table to check.
 * @param {Number} overlapColumn The index of the column to check.
 * @returns {Array.<module:table/tablewalker~TableSlot>}
 */

export function getHorizontallyOverlappingCells(table, overlapColumn) {
  var cellsToSplit = [];
  var tableWalker = new TableWalker(table);

  var _iterator4 = _createForOfIteratorHelper(tableWalker),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var slotInfo = _step4.value;
      var column = slotInfo.column,
          cellWidth = slotInfo.cellWidth;
      var cellEndColumn = column + cellWidth - 1;

      if (column < overlapColumn && overlapColumn <= cellEndColumn) {
        cellsToSplit.push(slotInfo);
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return cellsToSplit;
}
/**
 * Splits the table cell vertically.
 *
 * @param {module:engine/model/element~Element} tableCell
 * @param {Number} columnIndex The table cell column index.
 * @param {Number} splitColumn The index of column to split cell on.
 * @param {module:engine/model/writer~Writer} writer
 * @returns {module:engine/model/element~Element} Created table cell.
 */

export function splitVertically(tableCell, columnIndex, splitColumn, writer) {
  var colspan = parseInt(tableCell.getAttribute('colspan'));
  var newColspan = splitColumn - columnIndex;
  var newCellAttributes = {};
  var newCellColSpan = colspan - newColspan;

  if (newCellColSpan > 1) {
    newCellAttributes.colspan = newCellColSpan;
  }

  var rowspan = parseInt(tableCell.getAttribute('rowspan') || 1);

  if (rowspan > 1) {
    newCellAttributes.rowspan = rowspan;
  }

  var newCell = createEmptyTableCell(writer, writer.createPositionAfter(tableCell), newCellAttributes); // Update the colspan attribute after updating table.

  updateNumericAttribute('colspan', newColspan, tableCell, writer);
  return newCell;
}
/**
 * Adjusts table cell dimensions to not exceed limit row and column.
 *
 * If table cell width (or height) covers a column (or row) that is after a limit column (or row)
 * this method will trim "colspan" (or "rowspan") attribute so the table cell will fit in a defined limits.
 *
 * @param {module:engine/model/element~Element} tableCell
 * @param {Number} cellRow
 * @param {Number} cellColumn
 * @param {Number} limitRow
 * @param {Number} limitColumn
 * @param {module:engine/model/writer~Writer} writer
 */

export function trimTableCellIfNeeded(tableCell, cellRow, cellColumn, limitRow, limitColumn, writer) {
  var colspan = parseInt(tableCell.getAttribute('colspan') || 1);
  var rowspan = parseInt(tableCell.getAttribute('rowspan') || 1);
  var endColumn = cellColumn + colspan - 1;

  if (endColumn > limitColumn) {
    var trimmedSpan = limitColumn - cellColumn + 1;
    updateNumericAttribute('colspan', trimmedSpan, tableCell, writer, 1);
  }

  var endRow = cellRow + rowspan - 1;

  if (endRow > limitRow) {
    var _trimmedSpan = limitRow - cellRow + 1;

    updateNumericAttribute('rowspan', _trimmedSpan, tableCell, writer, 1);
  }
} // Sets proper heading attributes to a cropped table.

function addHeadingsToCroppedTable(croppedTable, sourceTable, startRow, startColumn, writer) {
  var headingRows = parseInt(sourceTable.getAttribute('headingRows') || 0);

  if (headingRows > 0) {
    var headingRowsInCrop = headingRows - startRow;
    updateNumericAttribute('headingRows', headingRowsInCrop, croppedTable, writer, 0);
  }

  var headingColumns = parseInt(sourceTable.getAttribute('headingColumns') || 0);

  if (headingColumns > 0) {
    var headingColumnsInCrop = headingColumns - startColumn;
    updateNumericAttribute('headingColumns', headingColumnsInCrop, croppedTable, writer, 0);
  }
}
/**
 * Removes columns that have no cells anchored.
 *
 * In table below:
 *
 *     +----+----+----+----+----+----+----+
 *     | 00 | 01      | 03 | 04      | 06 |
 *     +----+----+----+----+         +----+
 *     | 10 | 11      | 13 |         | 16 |
 *     +----+----+----+----+----+----+----+
 *     | 20 | 21      | 23 | 24      | 26 |
 *     +----+----+----+----+----+----+----+
 *                  ^--- empty ---^
 *
 * Will remove columns 2 and 5.
 *
 * **Note:** This is a low-level helper method for clearing invalid model state when doing table modifications.
 * To remove a column from a table use {@link module:table/tableutils~TableUtils#removeColumns `TableUtils.removeColumns()`}.
 *
 * @protected
 * @param {module:engine/model/element~Element} table
 * @param {module:table/tableutils~TableUtils} tableUtils
 * @returns {Boolean} True if removed some columns.
 */


export function removeEmptyColumns(table, tableUtils) {
  var width = tableUtils.getColumns(table);
  var columnsMap = new Array(width).fill(0);

  var _iterator5 = _createForOfIteratorHelper(new TableWalker(table)),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _ref4 = _step5.value;
      var column = _ref4.column;
      columnsMap[column]++;
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  var emptyColumns = columnsMap.reduce(function (result, cellsCount, column) {
    return cellsCount ? result : [].concat(_toConsumableArray(result), [column]);
  }, []);

  if (emptyColumns.length > 0) {
    // Remove only last empty column because it will recurrently trigger removing empty rows.
    var emptyColumn = emptyColumns[emptyColumns.length - 1]; // @if CK_DEBUG_TABLE // console.log( `Removing empty column: ${ emptyColumn }.` );

    tableUtils.removeColumns(table, {
      at: emptyColumn
    });
    return true;
  }

  return false;
}
/**
 * Removes rows that have no cells anchored.
 *
 * In table below:
 *
 *     +----+----+----+
 *     | 00 | 01 | 02 |
 *     +----+----+----+
 *     | 10 | 11 | 12 |
 *     +    +    +    +
 *     |    |    |    | <-- empty
 *     +----+----+----+
 *     | 30 | 31 | 32 |
 *     +----+----+----+
 *     | 40      | 42 |
 *     +         +    +
 *     |         |    | <-- empty
 *     +----+----+----+
 *     | 60 | 61 | 62 |
 *     +----+----+----+
 *
 * Will remove rows 2 and 5.
 *
 * **Note:** This is a low-level helper method for clearing invalid model state when doing table modifications.
 * To remove a row from a table use {@link module:table/tableutils~TableUtils#removeRows `TableUtils.removeRows()`}.
 *
 * @protected
 * @param {module:engine/model/element~Element} table
 * @param {module:table/tableutils~TableUtils} tableUtils
 * @returns {Boolean} True if removed some rows.
 */

export function removeEmptyRows(table, tableUtils) {
  var emptyRows = [];
  var tableRowCount = tableUtils.getRows(table);

  for (var rowIndex = 0; rowIndex < tableRowCount; rowIndex++) {
    var tableRow = table.getChild(rowIndex);

    if (tableRow.isEmpty) {
      emptyRows.push(rowIndex);
    }
  }

  if (emptyRows.length > 0) {
    // Remove only last empty row because it will recurrently trigger removing empty columns.
    var emptyRow = emptyRows[emptyRows.length - 1]; // @if CK_DEBUG_TABLE // console.log( `Removing empty row: ${ emptyRow }.` );

    tableUtils.removeRows(table, {
      at: emptyRow
    });
    return true;
  }

  return false;
}
/**
 * Removes rows and columns that have no cells anchored.
 *
 * In table below:
 *
 *     +----+----+----+----+
 *     | 00      | 02      |
 *     +----+----+         +
 *     | 10      |         |
 *     +----+----+----+----+
 *     | 20      | 22 | 23 |
 *     +         +    +    +
 *     |         |    |    | <-- empty row
 *     +----+----+----+----+
 *             ^--- empty column
 *
 * Will remove row 3 and column 1.
 *
 * **Note:** This is a low-level helper method for clearing invalid model state when doing table modifications.
 * To remove a rows from a table use {@link module:table/tableutils~TableUtils#removeRows `TableUtils.removeRows()`} and
 * {@link module:table/tableutils~TableUtils#removeColumns `TableUtils.removeColumns()`} to remove a column.
 *
 * @protected
 * @param {module:engine/model/element~Element} table
 * @param {module:table/tableutils~TableUtils} tableUtils
 */

export function removeEmptyRowsColumns(table, tableUtils) {
  var removedColumns = removeEmptyColumns(table, tableUtils); // If there was some columns removed then cleaning empty rows was already triggered.

  if (!removedColumns) {
    removeEmptyRows(table, tableUtils);
  }
}
/**
 * Returns adjusted last row index if selection covers part of a row with empty slots (spanned by other cells).
 * The `dimensions.lastRow` is equal to last row index but selection might be bigger.
 *
 * This happens *only* on rectangular selection so we analyze a case like this:
 *
 *        +---+---+---+---+
 *      0 | a | b | c | d |
 *        +   +   +---+---+
 *      1 |   | e | f | g |
 *        +   +---+   +---+
 *      2 |   | h |   | i | <- last row, each cell has rowspan = 2,
 *        +   +   +   +   +    so we need to return 3, not 2
 *      3 |   |   |   |   |
 *        +---+---+---+---+
 *
 * @param {module:engine/model/element~Element} table
 * @param {Object} dimensions
 * @param {Number} dimensions.firstRow
 * @param {Number} dimensions.firstColumn
 * @param {Number} dimensions.lastRow
 * @param {Number} dimensions.lastColumn
 * @returns {Number} Adjusted last row index.
 */

export function adjustLastRowIndex(table, dimensions) {
  var lastRowMap = Array.from(new TableWalker(table, {
    startColumn: dimensions.firstColumn,
    endColumn: dimensions.lastColumn,
    row: dimensions.lastRow
  }));
  var everyCellHasSingleRowspan = lastRowMap.every(function (_ref5) {
    var cellHeight = _ref5.cellHeight;
    return cellHeight === 1;
  }); // It is a "flat" row, so the last row index is OK.

  if (everyCellHasSingleRowspan) {
    return dimensions.lastRow;
  } // Otherwise get any cell's rowspan and adjust the last row index.


  var rowspanAdjustment = lastRowMap[0].cellHeight - 1;
  return dimensions.lastRow + rowspanAdjustment;
}
/**
 * Returns adjusted last column index if selection covers part of a column with empty slots (spanned by other cells).
 * The `dimensions.lastColumn` is equal to last column index but selection might be bigger.
 *
 * This happens *only* on rectangular selection so we analyze a case like this:
 *
 *       0   1   2   3
 *     +---+---+---+---+
 *     | a             |
 *     +---+---+---+---+
 *     | b | c | d     |
 *     +---+---+---+---+
 *     | e     | f     |
 *     +---+---+---+---+
 *     | g | h         |
 *     +---+---+---+---+
 *               ^
 *              last column, each cell has colspan = 2, so we need to return 3, not 2
 *
 * @param {module:engine/model/element~Element} table
 * @param {Object} dimensions
 * @param {Number} dimensions.firstRow
 * @param {Number} dimensions.firstColumn
 * @param {Number} dimensions.lastRow
 * @param {Number} dimensions.lastColumn
 * @returns {Number} Adjusted last column index.
 */

export function adjustLastColumnIndex(table, dimensions) {
  var lastColumnMap = Array.from(new TableWalker(table, {
    startRow: dimensions.firstRow,
    endRow: dimensions.lastRow,
    column: dimensions.lastColumn
  }));
  var everyCellHasSingleColspan = lastColumnMap.every(function (_ref6) {
    var cellWidth = _ref6.cellWidth;
    return cellWidth === 1;
  }); // It is a "flat" column, so the last column index is OK.

  if (everyCellHasSingleColspan) {
    return dimensions.lastColumn;
  } // Otherwise get any cell's colspan and adjust the last column index.


  var colspanAdjustment = lastColumnMap[0].cellWidth - 1;
  return dimensions.lastColumn + colspanAdjustment;
}